module.exports = __webpack_public_path__ + "static/media/linear-information.fb846a2d.svg";